import { memo } from 'react'

import { AddCircle, Refresh } from '@mui/icons-material'
import { Box, Button, styled, SxProps, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { AnimatedCounterButton } from '@shared/components/MaterialUIEnhancements/IconButton'

export const ListOperationBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  columnGap: theme.spacing(2),
  marginLeft: 'auto',
}))

type BasicListOperationProps = {
  refreshAction: () => void
  createAction: () => void
  sx?: SxProps
}

const BasicListOperationRaw = ({ refreshAction, createAction, sx }: BasicListOperationProps) => {
  const { t } = useTranslation()

  return (
    <ListOperationBox sx={sx}>
      <Tooltip title={t('refresh')} placement="left">
        <AnimatedCounterButton action={refreshAction}>
          {({ key, ...props }) => <Refresh key={key} {...props} />}
        </AnimatedCounterButton>
      </Tooltip>
      <Button variant="contained" endIcon={<AddCircle />} onClick={createAction}>
        {t('create')}
      </Button>
    </ListOperationBox>
  )
}

export const BasicListOperation = memo(BasicListOperationRaw)
